import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useCallback } from "react";
import carecentreTokens from "../../tokens";
import { CcMemberPickerSelectionIcon } from "./CcMemberPickerIcons";

const t = carecentreTokens;

const useStyles = makeStyles(() => ({
  card: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 12px",
    borderRadius: 10,
    border: `1px solid ${t.color.line}`,
    background: t.color.bgCard,
    cursor: "pointer",
    transition: "background-color 120ms ease, border-color 120ms ease",
    "&:not(:last-child)": {
      marginBottom: 8,
    },
    "&:focus": {
      outline: `2px solid ${t.color.primary}`,
      outlineOffset: 2,
    },
  },
  selected: {
    backgroundColor: t.color.primaryFaint,
    borderColor: t.color.primarySoft,
  },
  rowMain: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  affordance: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    marginLeft: 4,
    color: t.color.primary,
    "& svg": {
      fontSize: 22,
    },
  },
}));

const CcMemberPickerCard = ({
  selected = false,
  onToggle,
  children,
  disabled = false,
}) => {
  const classes = useStyles();

  const handleActivate = useCallback(() => {
    if (disabled) return;
    onToggle?.(!selected);
  }, [disabled, onToggle, selected]);

  const handleKeyDown = useCallback(
    (e) => {
      if (disabled) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleActivate();
      }
    },
    [disabled, handleActivate],
  );

  return (
    <Box
      className={clsx(classes.card, { [classes.selected]: selected })}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-pressed={selected}
      aria-disabled={disabled}
    >
      <Box className={classes.rowMain}>{children}</Box>
      <Box className={classes.affordance} aria-hidden="true">
        <CcMemberPickerSelectionIcon selected={selected} />
      </Box>
    </Box>
  );
};

export default CcMemberPickerCard;
